export default {
  /**
   * 商品分類条件の標準フォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * 商品コード
       */
      item: undefined,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(item) {
    return {
      company: item.company,
      itemCode: item.item.code,
    }
  },
  /**
   * applyToに対してitemを適用する
   */
  applyPayload(applyTo, item) {
    applyTo.key = new Date().getTime().toString()
    applyTo.company = item.company
    applyTo.item = item.item
  },
}
